// Fase 17.3, Plano 09 (D-20) — cliente HTTP e utilitários da tela "Importar área e peças por gancheira".
import type {
  ArquivoDadosTecnicosDto,
  CasouPorDadosTecnicos,
  LinhaPreviaDadosTecnicosDto,
  PreviaDadosTecnicosDto,
  ResultadoDadosTecnicosDto,
  SituacaoLinhaDadosTecnicos,
} from '@pieltec/contracts';
import { apiMutate } from '../csrf-fetch';
import { celulaCsv } from './importacao-cargamaquina';
import { lerErroApi } from '../vendas/erro-api';

export const ROTULO_SITUACAO_LINHA: Readonly<Record<SituacaoLinhaDadosTecnicos, string>> = {
  ATUALIZA: 'Atualiza',
  SEM_ALTERACAO: 'Sem alteração',
  ERRO: 'Erro',
};

export const ROTULO_CASOU_POR: Readonly<Record<CasouPorDadosTecnicos, string>> = {
  CODIGO: 'Código',
  CODIGO_NORMALIZADO: 'Código (ignorando espaços e caixa)',
  CODIGO_LEGADO: 'Código legado',
};

const ROTA_IMPORTACOES = '/api/v1/roteiros/importacoes/dados-tecnicos';
const ERRO_PADRAO = 'Não foi possível processar o arquivo. Tente novamente.';

async function chamar<T>(caminho: string, corpo: ArquivoDadosTecnicosDto): Promise<T> {
  const resposta = await apiMutate(`${ROTA_IMPORTACOES}/${caminho}`, { method: 'POST', body: corpo });
  if (!resposta.ok) {
    const erro = await lerErroApi(resposta, ERRO_PADRAO);
    throw new Error(resposta.status === 403 ? 'Você não tem permissão para importar dados técnicos.' : erro.mensagem);
  }
  return (await resposta.json()) as T;
}

export function previaDadosTecnicos(corpo: ArquivoDadosTecnicosDto): Promise<PreviaDadosTecnicosDto> {
  return chamar<PreviaDadosTecnicosDto>('previa', corpo);
}

export function confirmarDadosTecnicos(corpo: ArquivoDadosTecnicosDto): Promise<ResultadoDadosTecnicosDto> {
  return chamar<ResultadoDadosTecnicosDto>('confirmar', corpo);
}

/** CSV das linhas recusadas para o PCP corrigir e reenviar: `;`, UTF-8 com BOM e prefixo `'` contra injeção de fórmula (T-17.3-09-04). */
export function linhasComErroParaCsv(linhas: readonly Pick<LinhaPreviaDadosTecnicosDto, 'linha' | 'codigo' | 'erro'>[]): string {
  const corpo = [
    'linha;codigo;erro',
    ...linhas.map((linha) => [String(linha.linha), linha.codigo, linha.erro ?? ''].map(celulaCsv).join(';')),
  ];
  return String.fromCharCode(0xfeff) + corpo.join('\r\n') + '\r\n';
}

/** Texto do diálogo de confirmação. */
export function textoConfirmacaoDadosTecnicos(atualiza: number): string {
  return `${atualiza} peça(s) terão área ou peças por gancheira atualizadas.`;
}
